// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1567":"d58b2a72b54295dc","2741":"653c787f2490dc24","9651":"bddd959a7c85efc2"}[chunkId] + ".js";
};